import React, { useState, useEffect } from 'react';
import { Box, Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField } from '@mui/material';

export const SelectQuestionWithOther = ({ question, answer, onAnswerChange }) => {
  const options = question.q_options;
  const [selectedValue, setSelectedValue] = useState('');
  const [otherText, setOtherText] = useState('');
  const [showOtherInput, setShowOtherInput] = useState(false);

  useEffect(() => {
    setSelectedValue('');
    setOtherText('');
    setShowOtherInput(false);
  }, [question.id]);

  useEffect(() => {
    if (answer) {
      if (options && options.includes(answer)) {
        setSelectedValue(answer);
        setShowOtherInput(false);
        setOtherText('');
      } else if (answer !== '') {
        setSelectedValue('__other__');
        setOtherText(answer);
        setShowOtherInput(true);
      }
    }
  }, [answer, options, question.id]);

  const [isNA, setIsNA] = useState(answer === 'N/A');

  useEffect(() => {
    setIsNA(answer === 'N/A');
  }, [question.id]);

  if (!options || !Array.isArray(options)) return null;

  const handleNAChange = (e) => {
    const checked = e.target.checked;
    setIsNA(checked);
    if (checked) {
      setSelectedValue('');
      setOtherText('');
      setShowOtherInput(false);
      onAnswerChange('N/A');
    } else {
      onAnswerChange('');
    }
  };

  const handleSelectChange = (event) => {
    const value = event.target.value;
    setSelectedValue(value);

    if (value === '__other__') {
      setShowOtherInput(true);
      onAnswerChange(otherText);
    } else {
      setShowOtherInput(false);
      setOtherText('');
      onAnswerChange(value);
    }
  };

  const handleOtherTextChange = (event) => {
    const text = event.target.value;
    setOtherText(text);
    onAnswerChange(text);
  };

  return (
    <Box sx={{ width: '100%', margin: '0 auto' }}>
      <FormControl fullWidth disabled={isNA}>
        <InputLabel id={`select-label-${question.id}`}>Select an option</InputLabel>
        <Select
          label='Select an option'
          labelId={`select-label-${question.id}`}
          id={`select-${question.id}`}
          value={selectedValue}
          onChange={handleSelectChange}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ddd',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2aa1d3',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2aa1d3',
            },
          }}
        >
          <MenuItem value="">
            <em>None</em>
          </MenuItem>
          {options.map((option, index) => (
            <MenuItem key={`${option}-${index}`} value={option}>
              {option}
            </MenuItem>
          ))}
          <MenuItem value="__other__">
            Other
          </MenuItem>
        </Select>
      </FormControl>

      {showOtherInput && !isNA && (
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Please specify..."
          value={otherText}
          onChange={handleOtherTextChange}
          sx={{
            mt: 2,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#ddd',
              },
              '&:hover fieldset': {
                borderColor: '#2aa1d3',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#2aa1d3',
              },
            },
          }}
        />
      )}
      {!question.required && (
        <FormControlLabel
          control={
            <Checkbox
              checked={isNA}
              onChange={handleNAChange}
              sx={{
                color: '#ddd',
                '&.Mui-checked': { color: '#2aa1d3' },
              }}
            />
          }
          label="N/A"
          sx={{ mt: 1 }}
        />
      )}
    </Box>
  );
};